import httpClient, { postJson, postForm } from '../config/HttpClient'

export interface Posto {
  id: number
  nome: string
}

export interface Caixa {
  id: number
  nome: string
  posto_id: number
}

export interface EssencialAberturaCaixa {
  caixas: Caixa[]
  postos: Posto[]
}

export interface SessaoCaixaResumo {
  terminal: string
  valorAbertura: number
  dataAbertura: number
}

export interface EssencialFechoCaixa {
  sessaoCaixa: SessaoCaixaResumo | null
  saldoCaixa: number
  saldoLevantadoCaixa: number
  vendasTotais: number
  vendasTotaisCash: number
}

export interface EssencialLevantarCash {
  sessaoCaixa: SessaoCaixaResumo | null
  saldoCaixa: number
}

export interface OperacaoResultado {
  sucesso: boolean
  mensagem: string
}

export interface FecharCaixaResultado extends OperacaoResultado {
  redirectUrl: string
}

interface RespostaOperacao {
  type: 'sucesso' | 'erro'
  msg: string
  redirect: string
}

class CaixaService {
  async essencialToAberturaCaixa(): Promise<EssencialAberturaCaixa> {
    const resultado = await postJson<Partial<EssencialAberturaCaixa>>('/api/v1/auxiliar/essencial-to-abertura-caixa')

    return {
      caixas: resultado.caixas ?? [],
      postos: resultado.postos ?? []
    }
  }

  async essencialToFechoCaixa(): Promise<EssencialFechoCaixa> {
    const resultado = await postJson<Partial<EssencialFechoCaixa>>('/api/v1/auxiliar/essencial-to-fecho-caixa')

    return {
      sessaoCaixa: resultado.sessaoCaixa ?? null,
      saldoCaixa: resultado.saldoCaixa ?? 0,
      saldoLevantadoCaixa: resultado.saldoLevantadoCaixa ?? 0,
      vendasTotais: resultado.vendasTotais ?? 0,
      vendasTotaisCash: resultado.vendasTotaisCash ?? 0
    }
  }

  async essencialToLevantarCashCaixa(): Promise<EssencialLevantarCash> {
    const resultado = await postJson<Partial<EssencialLevantarCash>>('/api/v1/auxiliar/essencial-to-levantar-cash-do-caixa')

    return {
      sessaoCaixa: resultado.sessaoCaixa ?? null,
      saldoCaixa: resultado.saldoCaixa ?? 0
    }
  }

  async abrirCaixa(terminal: string, caixaId: number, valorTexto: string, obs = ''): Promise<OperacaoResultado> {
    const resposta = await postForm<RespostaOperacao>('/api-pos/caixa/iniciar-caixa', {
      terminal,
      'caixa.id': String(caixaId),
      valorTexto,
      obs
    })

    return { sucesso: resposta.type === 'sucesso', mensagem: resposta.msg }
  }

  async fecharCaixa(valorTexto: string): Promise<FecharCaixaResultado> {
    const resposta = await postForm<RespostaOperacao>('/api-pos/caixa/fechar-caixa', { valorTexto })

    return {
      sucesso: resposta.type === 'sucesso',
      mensagem: resposta.msg,
      redirectUrl: `${httpClient.baseURL}${resposta.redirect}`
    }
  }

  async levantarCashCaixa(valorTexto: string, motivo: string): Promise<OperacaoResultado> {
    const resposta = await postForm<RespostaOperacao>('/api-pos/caixa/levantar-cash-caixa', { valorTexto, motivo })

    return { sucesso: resposta.type === 'sucesso', mensagem: resposta.msg }
  }

  listarCaixas(): void {}
}

export default new CaixaService()
